import React from 'react';
import CustomLink from '../../../UI/CustomLink';
import styles from './SearchResultitem.module.scss';

const SearchResultItem = ({
  username, productLink, imgUrl, title, categories,
}) => (
  <CustomLink
    href="/[username]/[id]"
    as={`/${username}/${productLink}`}
    className={styles.item}
  >
    <div
      className={styles.itemImg}
      style={{ backgroundImage: `url(${imgUrl})` }}
    />
    <div className={styles.itemText}>
      <div>{title}</div>
      <div className={styles.itemCategories}>
        {categories?.map((cat) => cat.name).join('/')}
      </div>
    </div>
  </CustomLink>
);

export default SearchResultItem;
